import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=a67919be&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=a67919be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67919be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67919be')) {
      api.createRecord('a67919be', component.options)
    } else {
      api.reload('a67919be', component.options)
    }
    module.hot.accept("./PrivacyAgreement.vue?vue&type=template&id=a67919be&scoped=true&", function () {
      api.rerender('a67919be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agreement/PrivacyAgreement.vue"
export default component.exports